import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers-ded08042.js';
import styled from '@appbaseio/vue-emotion';

var _templateObject;
var Title = styled('h2')(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tmargin: 0 0 8px;\n\tfont-size: 1rem;\n\tcolor: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.titleColor;
});

export { Title as T };
